// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Offer48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Offer48Filled: FC<Offer48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M22.325 44c-.4 0-.792-.067-1.175-.2a2.289 2.289 0 0 1-.975-.65L4.875 27.8a2.506 2.506 0 0 1-.675-.975 3.075 3.075 0 0 1-.225-1.125c0-.367.075-.742.225-1.125.15-.383.375-.725.675-1.025L23.525 4.9a3.12 3.12 0 0 1 .975-.65A2.92 2.92 0 0 1 25.675 4h15.35c.833 0 1.542.292 2.125.875s.875 1.292.875 2.125v15.3c0 .4-.083.783-.25 1.15a3.203 3.203 0 0 1-.65.95l-18.7 18.75c-.267.3-.592.517-.975.65s-.758.2-1.125.2Zm13.45-29.2c.7 0 1.308-.258 1.825-.775.517-.517.775-1.125.775-1.825s-.258-1.308-.775-1.825c-.517-.517-1.125-.775-1.825-.775s-1.308.258-1.825.775c-.517.517-.775 1.125-.775 1.825s.258 1.308.775 1.825c.517.517 1.125.775 1.825.775Z" />
        </svg>
    );
};

export default Offer48Filled;
